import { render, staticRenderFns } from "./job_ability.vue?vue&type=template&id=40fa8977&scoped=true"
import script from "./job_ability.vue?vue&type=script&lang=js"
export * from "./job_ability.vue?vue&type=script&lang=js"
import style0 from "./job_ability.vue?vue&type=style&index=0&id=40fa8977&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fa8977",
  null
  
)

export default component.exports